import { render, staticRenderFns } from "./BiotimeDeviceView.vue?vue&type=template&id=71e063f7&scoped=true&"
import script from "./BiotimeDeviceView.vue?vue&type=script&lang=js&"
export * from "./BiotimeDeviceView.vue?vue&type=script&lang=js&"
import style0 from "./BiotimeDeviceView.vue?vue&type=style&index=0&id=71e063f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e063f7",
  null
  
)

export default component.exports